/**
 * Client-portal entrypoint to the marketing calendar.
 *
 * Redirects /portal/calendar → /portal/calendar/{user.client_id} so the
 * shared ClientCalendarPage receives the expected :clientId path param
 * and renders the read-only / sign-off variant of the dialog (driven by
 * user.role inside the page itself).
 */
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function PortalCalendarRedirect() {
  const { user } = useAuth();
  if (!user) return null;
  if (!user.client_id) {
    return (
      <div className="p-6 text-sm text-zinc-600">
        Your account isn&apos;t linked to a client yet. Please contact your
        account manager.
      </div>
    );
  }
  return <Navigate to={`/portal/calendar/${user.client_id}`} replace />;
}
